import React from 'react'
import { EnumDialogs, useDialogStore } from "services/store/dialog-store"
import { DialogAutenticarSenha } from "../dialog-autenticar-senha/dialog-autenticar-senha";
import { DialogSelecionarContrato } from '../dialog-selecionar-contrato/dialog-selecionar-contrato';
import { useEmpresaAtual } from 'services/hooks/empresa';
import { DialogSelecionarEmpresa } from '../dialog-selecionar-empresa/dialog-selecionar-empresa';

export const DialogModaisPublic = () => {
    const { dialogs } = useDialogStore(state => state);
    const { getEmpresaAtual } = useEmpresaAtual()
    if (getEmpresaAtual()) return null
    return <>
        {dialogs[EnumDialogs.Autenticar].aberto && (
            <DialogAutenticarSenha
                aberto={dialogs[EnumDialogs.Autenticar].aberto}
                {...dialogs[EnumDialogs.Autenticar].props}
            />
        )}
        {dialogs[EnumDialogs.SelecionarContrato].aberto && (
            <DialogSelecionarContrato
                aberto={dialogs[EnumDialogs.SelecionarContrato].aberto}
                {...dialogs[EnumDialogs.SelecionarContrato].props}
            />
        )}
        {dialogs[EnumDialogs.SelecionarEmpresa].aberto && (
            <DialogSelecionarEmpresa
                aberto={dialogs[EnumDialogs.SelecionarEmpresa].aberto}
                {...dialogs[EnumDialogs.SelecionarEmpresa].props}
            />
        )}
    </>
}